export default __webpack_public_path__ + "static/mobilehero-bf6baded2efe0a76dfe0ba7c0afee33d.jpg";